<template>
  <div>
    <div id="streetMap"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      map: null,
    };
  },
  props: {
    coordinate: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: "",
    },
  },
  watch: {
    coordinate: {
      handler(n, o) {
        this.$nextTick(() => {
          this.initMap();
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // this.initMap();
  },
  methods: {
    handleAddMark() {
      let marker = new AMap.Marker({
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [this.coordinate[0] + "", this.coordinate[1] + ""],
        label: "测试",
      });
      marker.setLabel({
        offset: new AMap.Pixel(10, 10), //设置文本标注偏移量
        content: `<div class='info'>${this.name}</div>`, //设置文本标注内容
        direction: "bottom", //设置文本标注方位
      });
      marker.on("click", this.handleClick);
      return marker;
    },
    handleClick(e) {
      console.log(e, "点击成功");
      this.$emit("clickStreet");
    },
    initMap() {
      if (!this.coordinate) return;
      this.map = new AMap.Map("streetMap", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 20, //初始地图级别
        center: this.coordinate, //初始地图中心点
        // showIndoorMap: false, //关闭室内地图
        expandZoomRange: false,
      });
      this.map.add(this.handleAddMark());
      this.map.setFitView();
    },
  },
};
</script>
<style lang="less" scoped>
#streetMap {
  width: 100%;
  height: 562px;
}
::v-deep(.amap-logo),
::v-deep(.amap-copyright) {
  display: none !important;
}
::v-deep(.amap-marker-label) {
  border: 0;
  background-color: transparent;
}

::v-deep(.info) {
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border-radius: 0.25rem;
  position: fixed;
  top: 1rem;
  background-color: white;
  width: auto;
  min-width: 22rem;
  border-width: 0;
  right: 1rem;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);

  position: relative;
  top: 0;
  right: 0;
  min-width: 0;
}
</style>
